module.exports = __webpack_public_path__ + "static/media/Computer.a634efd2.png";